var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid fondo-main"},[_c('Nav'),_c('Header',{staticClass:"hide-on-med-and-down fondo-grass"}),_c('Schedule',{staticClass:"col s6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }